import React, {Component} from 'react';

class Chip extends Component {

    render() {
        const { label, color, modifiers, onClose } = this.props;

        let className = 'chip'; 
        if (modifiers) modifiers.forEach(m => className+= ` chip--${m}`);

        return (
            <div className={className} style={{ backgroundColor: color }}>
                <div className="chip__label">{label}</div>
                <div className="chip__close" onClick={onClose}></div>
            </div>
        );
    }
}

export { Chip };